import { ptBR } from "@mui/material/locale";
import { createTheme } from "@mui/material/styles";
import { ptBR as dataGridPtBR } from "@mui/x-data-grid/locales";

const { palette: _palette, ...MUI_THEME } = createTheme({}, dataGridPtBR, {}, ptBR);

export { MUI_THEME };
